import { HTTP } from './common'

export const Auth = {
  obtainToken (credentials) {
    let urlString = 'auth/obtain_token'
    return HTTP.post(urlString, credentials)
      .then(response => {
        return response.data
      },
      error => {
        return error.data
      }
      )
  },
  refreshToken (tokenInfo) {
    console.log('API REFRESH TOKEN')
    console.log(tokenInfo)
    let urlString = 'auth/refresh_token'
    return HTTP.post(urlString, tokenInfo)
      .then(response => {
        return response.data
      })
  }
}
